import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth, SAMLAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY || '',
  authDomain: `${process.env.FIREBASE_PROJECT_ID || ''}.firebaseapp.com`,
  databaseURL: `https://${process.env.FIREBASE_PROJECT_ID || ''}-default-rtdb.firebaseio.com`,
  projectId: process.env.FIREBASE_PROJECT_ID || '',
  storageBucket: `${process.env.FIREBASE_PROJECT_ID || ''}.firebasestorage.app`,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.FIREBASE_APP_ID || '',
};

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

try {
  console.log('Firebase auth required - initializing Firebase...');
  console.log('Firebase config:', {
    ...firebaseConfig,
    apiKey: firebaseConfig.apiKey ? `${firebaseConfig.apiKey.substring(0, 10)}...` : 'missing',
  });

  if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
    console.error('Firebase configuration incomplete. Required: FIREBASE_API_KEY, FIREBASE_PROJECT_ID');
    throw new Error('Firebase configuration incomplete');
  }

  app = initializeApp(firebaseConfig);
  console.log('Firebase app initialized');

  auth = getAuth(app);
  console.log('Firebase Auth initialized');
} catch (error) {
  console.error('Failed to initialize Firebase:', error);
  app = null;
  auth = null;
}

export { auth };
export { app };

export const isFirebaseInitialized = (): boolean => {
  return auth !== null && app !== null;
};

/** Same SAML setup as dashboard `src/config/firebase.ts` — GCIP Microsoft federation. */
export const getSamlProvider = (): SAMLAuthProvider | null => {
  const providerId = (process.env.FIREBASE_SAML_PROVIDER_ID || '').trim();
  if (!providerId || typeof providerId !== 'string') {
    console.warn('Missing FIREBASE_SAML_PROVIDER_ID; Microsoft SSO unavailable');
    return null;
  }
  if (!providerId.startsWith('saml.') || providerId === 'saml.provider-id') {
    console.warn('Invalid FIREBASE_SAML_PROVIDER_ID; expected a real saml.* provider from Firebase');
    return null;
  }
  try {
    return new SAMLAuthProvider(providerId);
  } catch (e) {
    console.error('Failed to initialize SAML provider:', e);
    return null;
  }
};
